<button cm-link-button [cmOverlayTriggerFor]="uiBugOverlay" type="button"
	[matTooltip]="'More Information' | cmLocalize: 'Core/System.CmUiBug.MoreInformation.Button'">
	<ats-icon [name]="type"></ats-icon>
</button>

<cm-context-overlay #uiBugOverlay="cmOverlay">
	<span cm-overlay-title>{{bugTitle}}</span>
	{{content}}
</cm-context-overlay>
